"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@oozcitak/util");
const ObjectWriter_1 = require("./ObjectWriter");
const BaseWriter_1 = require("./BaseWriter");
/**
 * Serializes XML nodes into ES6 maps and arrays.
 */
class MapWriter extends BaseWriter_1.BaseWriter {
    /**
     * Produces an XML serialization of the given node.
     *
     * @param node - node to serialize
     * @param writerOptions - serialization options
     */
    serialize(node, writerOptions) {
        const options = util_1.applyDefaults(writerOptions, {
            format: "map",
            wellFormed: false,
            noDoubleEncoding: false,
            group: false
        });
        // convert to object
        const objectWriterOptions = util_1.applyDefaults(options, {
            format: "object",
            wellFormed: false,
            noDoubleEncoding: false
        });
        const objectWriter = new ObjectWriter_1.ObjectWriter(this._builderOptions);
        const val = objectWriter.serialize(node, objectWriterOptions);
        // recursively convert object into Map
        return this._convertObject(val);
    }
    /**
     * Recursively converts a JS object into an ES5 map.
     *
     * @param obj - a JS object
     */
    _convertObject(obj) {
        if (util_1.isArray(obj)) {
            for (let i = 0; i < obj.length; i++) {
                obj[i] = this._convertObject(obj[i]);
            }
            return obj;
        }
        else if (util_1.isObject(obj)) {
            const map = new Map();
            for (const key in obj) {
                map.set(key, this._convertObject(obj[key]));
            }
            return map;
        }
        else {
            return obj;
        }
    }
}
exports.MapWriter = MapWriter;
//# sourceMappingURL=MapWriter.js.map